const RUBLE = 'RUB';

const Currency = {
    isRuble: (currencyCode: string | undefined) => currencyCode === RUBLE,
}

export default Currency;